import { OrderCard } from "@web-app/components";
import { Order, Route } from "@web-app/types";

export default function OrdersTab({
  route,
  onViewDetails,
}: {
  onViewDetails: (id: string) => void;
  route: {
    details: Route | null;
    orders: Order[];
  } | null;
}) {
  if (!route) return null;
  if (!route.details) return null;

  const orders = route.orders;

  return (
    <div className="flex flex-col gap-2 h-[calc(100dvh-120px)] overflow-y-auto px-4 pb-10 lg:pb-20">
      {orders.map((order, index) => (
        <OrderCard
          key={order.id}
          order={order}
          routeIndex={index + 1}
          onViewDetails={() => onViewDetails(order.id)}
        />
      ))}
    </div>
  );
}
